import React from "react";
import { Theme } from "interfaces/theme";
import * as S from "./styles";

interface IEye {
  mode: Theme;
}
const Eye: React.FC<IEye> = ({ mode }) => {
  return (
    <S.Container mode={mode}>
      <S.Title>
        Elas são
        <br />o terror…
      </S.Title>
      <S.Text>
        <p>
          Essas bruxas disfarçadas de patricinhas vão aprontar altas travessuras
          nesse Halloween de beauté inspirado nos anos 2000 que acaba de
          aterrissar na sua ELLE View. Aperte o botão para ver as duas versões
          dessa turminha do mal!
        </p>
        <p>POR PEDRO CAMARGO</p>
      </S.Text>
      <S.Credits>
        <S.Column>
          <div>
            <span>Fotos:</span>
            <h6>Takeuchiss</h6>
          </div>
          <div>
            <span>Edição:</span>
            <h6>Pedro Camargo</h6>
          </div>
        </S.Column>
        <S.Column>
          <div>
            <span>Fotos:</span>
            <h6>Takeuchiss</h6>
          </div>
          <div>
            <span>Edição:</span>
            <h6>Pedro Camargo</h6>
          </div>
        </S.Column>
      </S.Credits>
    </S.Container>
  );
};

export default Eye;
